// removed by extract-text-webpack-plugin
module.exports = {"header":"header___1wEBe","close":"close___2pKIH","back":"back___2PHZf","illustration":"illustration___1Br95","title":"title___1b2gh","description":"description___3rzqk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Content/Header/index.scss
// module id = 97
// module chunks = 0